import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noEntriesTitle: {
    defaultMessage: 'No blacklist entries found',
    description: 'Title shown when blacklist table is empty',
    id: 'RzOpyn',
  },
  noEntriesDescription: {
    defaultMessage: 'Add addresses to your blacklist to flag potentially fraudulent orders.',
    description: 'Description shown when blacklist table is empty',
    id: 'pxXX+T',
  },
});
